// // You can customize the template with the help of this file

// //Template config options
// const themeConfig = {

//   app: {
//     appName: '',
// appLogoImage: [10005, 10006].includes(JSON.parse(localStorage.getItem('companyID'))) ? (JSON.parse(localStorage.getItem('staffRoleID')) === "Passenger" ? require('@src/assets/images/logo/Chariot-PassengerApp-Logo.png').default : require('@src/assets/images/logo/Chariot-LogoMain.png').default) : JSON.parse(localStorage.getItem('companyID')) === 10007 ? (JSON.parse(localStorage.getItem('staffRoleID')) === "Passenger" ? require('@src/assets/images/logo/groupbus.png').default : require('@src/assets/images/logo/groupbus.png').default) : JSON.parse(localStorage.getItem('companyID')) === 10010 ? (JSON.parse(localStorage.getItem('staffRoleID')) === "Passenger" ? require('@src/assets/images/logo/DE-PassengerApp-Logo.png').default : require('@src/assets/images/logo/DE-LogoMain.png').default) : (JSON.parse(localStorage.getItem('staffRoleID')) === "Passenger" ? require('@src/assets/images/logo/UKCB-PassengerApp-Logo.png').default : require('@src/assets/images/logo/UKCB-LogoMain.png').default),    //  appLogoImage: JSON.parse(localStorage.getItem('companyID')) === 10005 || JSON.parse(localStorage.getItem('companyID')) === 10006 ? (JSON.parse(localStorage.getItem('staffRoleID')) === "Passenger" ? require('@src/assets/images/logo/Chariot-PassengerApp-Logo.png').default : require('@src/assets/images/logo/Chariot-LogoMain.png').default) : (JSON.parse(localStorage.getItem('staffRoleID')) === "Passenger" ? require('@src/assets/images/logo/UKCB-PassengerApp-Logo.png').default : require('@src/assets/images/logo/UKCB-LogoMain.png').default),
// appLogoImageSmall: [10005, 10006].includes(JSON.parse(localStorage.getItem('companyID'))) ? require('@src/assets/images/logo/ChariotIcon.png').default : JSON.parse(localStorage.getItem('companyID')) === 10007 ? require('@src/assets/images/logo/GroupbusIcon.png').default : JSON.parse(localStorage.getItem('companyID')) === 10010 ? require('@src/assets/images/logo/DEIcon.png').default : require('@src/assets/images/logo/LoadingIcon.png').default
//   },
//   layout: {
//     isRTL: false,
//     skin: 'light', // light, dark, bordered, semi-dark
//     routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
//     type: 'vertical', // vertical, horizontal
//     contentWidth: 'full', // full, boxed
//     menu: {
//       isHidden: false,
//       isCollapsed: false
//     },
//     navbar: {
//       // ? For horizontal menu, navbar type will work for navMenu type
//       type: 'floating', // static , sticky , floating, hidden
//       backgroundColor: 'white' // BS color options [primary, success, etc]
//     },
//     footer: {
//       type: 'static' // static, sticky, hidden
//     },
//     customizer: false,
//     scrollTop: true // Enable scroll to top button
//   }
// }

// export default themeConfig


// You can customize the template with the help of this file
import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getLogo } from '../@core/layouts/components/navbar/store/UserDropDownStore'

// Function to create the theme config with dynamic logos
const useThemeConfig = () => {
  const [logoSrcPassenger, setLogoSrcPassenger] = useState(require('@src/assets/images/logo/Loading-LogoMain.png').default)
  const [logoSrcSideBar, setLogoSrcSideBar] = useState(require('@src/assets/images/logo/LoadingIcon.png').default)

  const dispatch = useDispatch()

  const GetSystemLogo = async () => {
    const response1 = await dispatch(
      getLogo({
        userType: JSON.parse(localStorage.getItem('staffRoleID')),
        companyID: JSON.parse(localStorage.getItem('companyID'))
      })
    )

    if (response1?.payload) {
      try {
       
        const NavBarLogoFile = response1.payload.navBarLogo
        const SideBarLogoFile = response1.payload.sideBarLogo

        const NavBarlogoPath = NavBarLogoFile ? require(`@src/assets/images/logo/${NavBarLogoFile}`).default : require('@src/assets/images/logo/Loading-LogoMain.png').default
        const SideBarlogoPath = SideBarLogoFile ? require(`@src/assets/images/logo/${SideBarLogoFile}`).default : require('@src/assets/images/logo/LoadingIcon.png').default

        setLogoSrcPassenger(NavBarlogoPath)
        setLogoSrcSideBar(SideBarlogoPath)
      } catch (error) {
        setLogoSrcPassenger(require('@src/assets/images/logo/Loading-LogoMain.png').default)
        setLogoSrcSideBar(require('@src/assets/images/logo/LoadingIcon.png').default)
      }
    }
  }

  useEffect(() => {
    GetSystemLogo()
  }, [])

  return { logoSrcPassenger, logoSrcSideBar }
}

// Template config options
const getThemeConfig = (logoSrcPassenger, logoSrcSideBar) => {
  return {
    app: {
      appName: '',
      appLogoImage:  logoSrcPassenger ? logoSrcPassenger : require('@src/assets/images/logo/Loading-LogoMain.png').default,
      appLogoImageSmall: logoSrcSideBar ? logoSrcSideBar : require('@src/assets/images/logo/LoadingIcon.png').default
    },
    layout: {
      isRTL: false,
      skin: 'light', // light, dark, bordered, semi-dark
      routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
      type: 'vertical', // vertical, horizontal
      contentWidth: 'full', // full, boxed
      menu: {
        isHidden: false,
        isCollapsed: false
      },
      navbar: {
        // ? For horizontal menu, navbar type will work for navMenu type
        type: 'floating', // static , sticky , floating, hidden
        backgroundColor: 'white' // BS color options [primary, success, etc]
      },
      footer: {
        type: 'static' // static, sticky, hidden
      },
      customizer: false,
      scrollTop: true // Enable scroll to top button
    }
  }
}

export { useThemeConfig, getThemeConfig }

// Default export for backward compatibility
export default getThemeConfig(
  require('@src/assets/images/logo/Loading-Logo.png').default,
  require('@src/assets/images/logo/Loading-LogoMain.png').default,
  require('@src/assets/images/logo/LoadingIcon.png').default
)
